// Copyright (c) StrangeBee 2024

import React from 'react';
import { ReportTemplateWidgetEnum, SortOptions } from 'thehive-sdk';
import { ColumnTitle } from '@Atoms/ColumnTitle/ColumnTitle';
import { useLocalMessage } from '@Helpers/locale';
import { Skeleton } from 'antd';
import { classList } from '@Helpers/className';

import './TableWidget.scss';

interface TableWidgetProps {
    _kind: ReportTemplateWidgetEnum;
    columns: string[];
    fangData?: boolean;
    filter?: any;
    sort?: SortOptions;
}

export const TableWidget = ({ columns, _kind, fangData }: TableWidgetProps) => {
    const i = useLocalMessage();

    if (_kind === ReportTemplateWidgetEnum.CustomFields) {
        columns = ['Custom Field 1', 'Custom Field 2', 'Custom Field 3'];
        return (
            <div className="table-widget__custom-fields">
                <div className="table-widget__custom-fields__item">
                    {columns?.map((column, index) => (
                        <div key={column} className="table-widget__custom-fields__item__row">
                            <ColumnTitle
                                className={classList(
                                    'table-widget__custom-fields__item__title',
                                    index === 0 && 'border-first',
                                    index === columns.length - 1 && 'border-last',
                                )}
                            >
                                {column}
                            </ColumnTitle>
                            <div className="table-widget__custom-fields__item__value">
                                <Skeleton
                                    key={`skeleton-${column}-skeleton`}
                                    title={false}
                                    paragraph={{ rows: 1, width: `100%` }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="table-widget">
            <div className="table-widget__columns">
                {columns?.map((column, index) => (
                    <div key={`column-${column}`} className="table-widget__columns__block">
                        <div
                            className={classList(
                                'table-widget__columns__block__item',
                                index === 0 && 'border-first',
                                index === columns.length - 1 && 'border-last',
                            )}
                        >
                            <ColumnTitle className={classList('table-widget__columns__title')}>
                                {i({ defaultMessage: column, id: `column.${column}` })}
                            </ColumnTitle>
                            {column === 'Data' && fangData && (
                                <div className="table-widget__columns__item__hint">Data will be fanged</div>
                            )}
                        </div>
                        <div className="table-widget__columns__skeleton">
                            <Skeleton
                                key={`skeleton-${column}-skeleton`}
                                title={false}
                                paragraph={{ rows: 3, width: `100%` }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
